import { canManageKraLibrary, canModifyKraRecord } from '@cfl/shared';

import { useSession } from '@/lib/session';

/**
 * The two KRA-library rules, resolved for the signed-in user.
 *
 * Both come straight out of `@cfl/shared`, which is the point: the API rejects with the
 * same two functions, so a greyed-out button and a 403 can never disagree about who may
 * do what. This is the courtesy copy — never the control.
 */
export function useKraPermissions() {
  const session = useSession();
  const user = session.status === 'authenticated' ? session.user : null;

  return {
    /** May author KRAs and groups at all — everyone but an individual contributor. */
    canManage: user !== null && canManageKraLibrary(user),
    /** May change this particular row: its author, or HR. */
    canModify: (record: { createdById: string | null }) =>
      user !== null && canModifyKraRecord(user, record),
    ownerNote: (record: { createdById: string | null; createdByName: string | null }) =>
      user !== null && canModifyKraRecord(user, record)
        ? undefined
        : `by ${record.createdByName ?? 'HR'} — ask them to change it`,
  };
}
